import { render, staticRenderFns } from "./TermsIcon.vue?vue&type=template&id=f76a0b70&"
import script from "./TermsIcon.vue?vue&type=script&lang=js&"
export * from "./TermsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports